import { render, staticRenderFns } from "./footer-panel.component.vue?vue&type=template&id=5eb6c26c&scoped=true&"
import script from "./footer-panel.component.vue?vue&type=script&lang=ts&"
export * from "./footer-panel.component.vue?vue&type=script&lang=ts&"
import style0 from "./footer-panel.component.vue?vue&type=style&index=0&id=5eb6c26c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5eb6c26c",
  null
  
)

export default component.exports